import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';
import './App.css';
import UserContext from './components/AccountContext';
import Views from './components/Views';
import { useEffect } from 'react';

function App() {
  console.log('REACT_APP_ENVIRONMENT');

  useEffect(() => {
    console.log('App.js montado');
    async function handleMessage(event) {
      try {
        let rota = null;
        const parsed = JSON.parse(event.data);
        const raw = parsed?.notification?.request?.trigger?.remoteMessage?.data?.data;
        const ios = parsed?.notification?.request?.trigger?.payload?.aps?.alert?.data;
        const fixo = parsed.notification.request.content.data;
        const responseData = typeof raw === 'string' ? JSON.parse(raw) : typeof fixo === 'string' ? JSON.parse(fixo) : raw;
        rota = responseData || ios || fixo;
        console.log('Rota responseData:', responseData);
        console.log('Rota extraída:', rota);
        if (rota.rota) {
          console.log('Rota recebida:', rota.rota);
          const notificacoes = localStorage.getItem('@notificacao');
          const notificacaoArray = notificacoes ? JSON.parse(notificacoes) : [];
          notificacaoArray.push(rota);
          localStorage.setItem('@notificacao', JSON.stringify(notificacaoArray));
          const eventCustom = new CustomEvent('novaNotificacao', { detail: rota });
          window.dispatchEvent(eventCustom);
        }
      } catch (e) {
        //alert('Erro ao processar mensagem:', e);
      }
    }
    console.log('Adicionando listener de mensagens');
    window.addEventListener('message', handleMessage);
    document.addEventListener('message', handleMessage);
    return () => {
      console.log('Removendo listener de mensagens');
      window.removeEventListener('message', handleMessage);
      document.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <UserContext>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Views />
      </ErrorBoundary>
    </UserContext>
  );
}

export default App;
